import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionbtnComponent } from './selectionbtn.component';
import { AngularMaterialModule } from '@app/material.module';

@NgModule({
    declarations: [
        SelectionbtnComponent
    ],
    imports: [
        CommonModule,
        AngularMaterialModule
    ],
    exports: [
        SelectionbtnComponent
    ]
})
export class SelectionbtnModule { }
